import React from 'react';
import {
    FaFacebook,
    FaInstagram,
    FaTwitter

  } from 'react-icons/fa';

  import {
MdEmail
  } from 'react-icons/md';
  import {
    FooterContainer,
    SocialMedia,
    SocialMediaWrap,
    SocialIcons,
    SocialIconLink,
  } from './FooterElemens';


const Footer = () => {
        return (
            <>
            <FooterContainer>
                <SocialMedia>
        <SocialMediaWrap>
          <SocialIcons>
            <SocialIconLink href='https://www.facebook.com/groups/1268515679864066' 
            target='_blank' aria-label='Facebook'>
              <FaFacebook />
            </SocialIconLink>
            <SocialIconLink href='https://www.instagram.com/bisharat.family/?hl=en' target='_blank' aria-label='Instagram'>
              <FaInstagram />
            {/* </SocialIconLink>
            <SocialIconLink href='/' target='_blank' aria-label='Youtube'>
              <FaYoutube /> */}
            </SocialIconLink>
            <SocialIconLink href='https://twitter.com/BisharatFamily?s=20' target='_blank' aria-label='Twitter'>
              <FaTwitter />
            </SocialIconLink>
            <SocialIconLink href='mailto:admin@bisharatfamily.com' aria-label='Email'>
              <MdEmail/>
            </SocialIconLink>
          </SocialIcons>
        </SocialMediaWrap>
      </SocialMedia>

      </FooterContainer>
      
            </>
        )
    
}


export default Footer;